module.exports = __webpack_public_path__ + "cef8afebbeec1b353a4b2c4164da90e3.pdf";